import { makeGetRequest } from "./restServices"

async function getDocumentation() {
    try {
        const res = await makeGetRequest('documentation')
        if (res.data.success)
            return res.data.data
    }
    catch (err) {
        console.log("err", err)
        return { success: false, data: {} }
    }

}
export { getDocumentation }